/* Alnerva — quantity-tier bundle, the theme's only script.

   Progressive enhancement, strictly. Without this file the tier radios are still the product
   form's `quantity` field and the page behaves exactly as it did before: picking "3 st" adds
   three of the currently selected variant. With it, tiers 2 and 3 reveal a colour/size select
   per garment, and one cart/add.js call adds the chosen combination.

   Two rules this file must never break:
   1. It never computes, formats or writes a price. Every amount on the page is rendered by
      Liquid from the real variant price; the discounts themselves are Shopify automatic
      discounts applied at checkout.
   2. It never invents a variant. A combination that does not exist, or is not available,
      disables the button and shows a message instead of guessing a substitute.

   All customer-facing strings arrive as data-* attributes from the locale file — no Swedish
   is hardcoded here. */

(function () {
  var roots = document.querySelectorAll('[data-bundle]');
  for (var i = 0; i < roots.length; i++) {
    init(roots[i]);
  }

  function init(root) {
    var form = root.closest('form');
    var payloadEl = root.querySelector('[data-bundle-variants]');
    if (!form || !payloadEl) return;

    var variants;
    try {
      variants = JSON.parse(payloadEl.textContent);
    } catch (e) {
      return; // leave the no-JS behaviour in place rather than half-enhance
    }
    if (!variants || !variants.length) return;

    var errorEl = root.querySelector('[data-bundle-error]');
    var button = form.querySelector('button[type="submit"]');
    var buttonLockedByLiquid = button ? button.disabled : false;
    var addUrl = root.getAttribute('data-add-url') || '/cart/add.js';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var radios = root.querySelectorAll('[data-bundle-radio]');
    var selects = root.querySelectorAll('[data-bundle-select]');
    var submitting = false;

    root.setAttribute('data-bundle-js', 'on');

    for (var s = 0; s < selects.length; s++) {
      selects[s].disabled = false;
      selects[s].addEventListener('change', validate);
    }
    for (var r = 0; r < radios.length; r++) {
      radios[r].addEventListener('change', sync);
    }

    sync();

    function currentQty() {
      for (var k = 0; k < radios.length; k++) {
        if (radios[k].checked) {
          return parseInt(radios[k].getAttribute('data-bundle-qty'), 10) || 1;
        }
      }
      return 1;
    }

    function sync() {
      var qty = currentQty();
      var panels = root.querySelectorAll('[data-bundle-picks]');
      for (var p = 0; p < panels.length; p++) {
        panels[p].hidden = parseInt(panels[p].getAttribute('data-bundle-picks'), 10) !== qty;
      }
      validate();
    }

    /* Resolve one garment's selects into a variant, or null when that combination
       was never created. Option order is the product's own option order. */
    function resolve(values) {
      for (var v = 0; v < variants.length; v++) {
        var options = variants[v].o;
        if (options.length !== values.length) continue;
        var same = true;
        for (var x = 0; x < options.length; x++) {
          if (options[x] !== values[x]) {
            same = false;
            break;
          }
        }
        if (same) return variants[v];
      }
      return null;
    }

    /* All garments for the chosen tier, or null if any one of them cannot be resolved. */
    function chosenVariants(qty) {
      var panel = root.querySelector('[data-bundle-picks="' + qty + '"]');
      if (!panel) return null;
      var picked = [];
      for (var n = 1; n <= qty; n++) {
        var fields = panel.querySelectorAll('[data-bundle-item="' + n + '"]');
        if (!fields.length) return null;
        var values = [];
        for (var f = 0; f < fields.length; f++) {
          var index = parseInt(fields[f].getAttribute('data-bundle-option'), 10);
          values[index] = fields[f].value;
        }
        var match = resolve(values);
        if (!match) return null;
        picked.push(match);
      }
      return picked;
    }

    function message(text) {
      if (!errorEl) return;
      errorEl.textContent = text || '';
      errorEl.hidden = !text;
    }

    function lock(disabled) {
      if (!button) return;
      button.disabled = buttonLockedByLiquid || disabled;
    }

    function validate() {
      if (submitting) return false;
      var qty = currentQty();
      if (qty < 2) {
        message('');
        lock(false);
        return true;
      }
      var picked = chosenVariants(qty);
      if (!picked) {
        message(root.getAttribute('data-msg-missing'));
        lock(true);
        return false;
      }
      for (var i = 0; i < picked.length; i++) {
        if (!picked[i].a) {
          message(root.getAttribute('data-msg-soldout'));
          lock(true);
          return false;
        }
      }
      message('');
      lock(false);
      return true;
    }

    form.addEventListener('submit', function (event) {
      var qty = currentQty();
      if (qty < 2) return; // one garment: the plain product form is already correct

      var picked = chosenVariants(qty);
      event.preventDefault();
      if (!picked || !validate()) return;

      submitting = true;
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      }

      var items = [];
      for (var i = 0; i < picked.length; i++) {
        items.push({ id: picked[i].id, quantity: 1 });
      }

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart/add ' + response.status);
          window.location.href = cartUrl;
        })
        .catch(function () {
          submitting = false;
          if (button) button.removeAttribute('aria-busy');
          lock(false);
          message(root.getAttribute('data-msg-failed'));
        });
    });
  }
})();
